/* eslint-disable @typescript-eslint/no-explicit-any */
import { defaultThemeMap as defaultStitchesThemeMap } from '../lib/stitches/react';
export const pxToRem = (px) => `${Number(px.toString().replace('px', '')) / 16}rem`;
export const remToPx = (rem) => `${Number(rem.toString().replace('rem', '')) * 16}px`;
export const defaultSpacing = {
    px: '1px',
    '0': '0',
    '0dot5': '0.125rem',
    '1': '0.25rem',
    '1dot5': '0.375rem',
    '2': '0.5rem',
    '2dot5': '0.625rem',
    '3': '0.75rem',
    '3dot5': '0.875rem',
    '4': '1rem',
    '5': '1.25rem',
    '6': '1.5rem',
    '7': '1.75rem',
    '8': '2rem',
    '9': '2.25rem',
    '10': '2.5rem',
    '11': '2.75rem',
    '12': '3rem',
    '14': '3.5rem',
    '16': '4rem',
    '20': '5rem',
    '24': '6rem',
    '28': '7rem',
    '32': '8rem',
    '36': '9rem',
    '40': '10rem',
    '44': '11rem',
    '48': '12rem',
    '52': '13rem',
    '56': '14rem',
    '60': '15rem',
    '64': '16rem',
    '72': '18rem',
    '80': '20rem',
    '96': '24rem' // 384px
};
export const defaultBreakpoints = {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px'
};
export const defaultSemanticColors = {
    // ------------------------------------------------------------------------
    // ******* Shades *********************************************************
    // ------------------------------------------------------------------------
    white: '#FFFFFF',
    black: '#000000',
    // ------------------------------------------------------------------------
    // ******* Neutral ********************************************************
    // ------------------------------------------------------------------------
    neutral25: '#FCFCFD',
    neutral50: '#F9FAFB',
    neutral100: '#F2F4F7',
    neutral200: '#EAECF0',
    neutral300: '#D0D5DD',
    neutral400: '#98A2B3',
    neutral500: '#667085',
    neutral600: '#475467',
    neutral700: '#344054',
    neutral800: '#1D2939',
    neutral900: '#101828',
    // ------------------------------------------------------------------------
    // ******* Semantic *******************************************************
    // ------------------------------------------------------------------------
    primary25: '#FCFAFF',
    primary50: '#F9F5FF',
    primary100: '#F4EBFF',
    primary200: '#E9D7FE',
    primary300: '#D6BBFB',
    primary400: '#B692F6',
    primary500: '#9E77ED',
    primary600: '#7F56D9',
    primary700: '#6941C6',
    primary800: '#53389E',
    primary900: '#42307D',
    secondary25: '#FCFCFD',
    secondary50: '#F9FAFB',
    secondary100: '#F2F4F7',
    secondary200: '#EAECF0',
    secondary300: '#D0D5DD',
    secondary400: '#98A2B3',
    secondary500: '#667085',
    secondary600: '#475467',
    secondary700: '#344054',
    secondary800: '#1D2939',
    secondary900: '#101828',
    danger25: '#FFFBFA',
    danger50: '#FEF3F2',
    danger100: '#FEE4E2',
    danger200: '#FECDCA',
    danger300: '#FDA29B',
    danger400: '#F97066',
    danger500: '#F04438',
    danger600: '#D92D20',
    danger700: '#B42318',
    danger800: '#912018',
    danger900: '#7A271A',
    warning25: '#FFFCF5',
    warning50: '#FFFAEB',
    warning100: '#FEF0C7',
    warning200: '#FEDF89',
    warning300: '#FEC84B',
    warning400: '#FDB022',
    warning500: '#F79009',
    warning600: '#DC6803',
    warning700: '#B54708',
    warning800: '#93370D',
    warning900: '#7A2E0E',
    success25: '#F6FEF9',
    success50: '#ECFDF3',
    success100: '#D1FADF',
    success200: '#A6F4C5',
    success300: '#6CE9A6',
    success400: '#32D583',
    success500: '#12B76A',
    success600: '#039855',
    success700: '#027A48',
    success800: '#05603A',
    success900: '#054F31',
    // ------------------------------------------------------------------------
    // ******* Components *****************************************************
    // ------------------------------------------------------------------------
    bodyBg: '$hiContrast',
    hoverBg: '$neutral50',
    hoverText: '$text',
    activeBg: '$neutral50',
    activeText: '$text',
    selectedBg: '$neutral50',
    selectedText: '$text',
    surface: '$hiContrast',
    hiContrast: '$white',
    loContrast: '$black',
    text: '$neutral900',
    textMuted: '$neutral600',
    borderColor: '$neutral300',
    separatorColor: '$neutral200',
    link: '$blue600',
    linkHover: '$blue600',
    linkActive: '$blue600',
    linkFocus: '$blue600',
    backdrop: 'rgba(52, 64, 84, 0.7)',
    errorText: '$danger500',
    errorBorder: '$danger300',
    successText: '$success500',
    successBorder: '$success300',
    warningText: '$warning500',
    warningBorder: '$warning300',
    primary: '$primary800',
    secondary: '$secondary800',
    danger: '$danger600',
    warning: '$warning600',
    success: '$success600'
};
export const defaultMiscColors = {
    // ------------------------------------------------------------------------
    // ******* Misc ***********************************************************
    // ------------------------------------------------------------------------
    grayBlue25: '#FCFCFD',
    grayBlue50: '#F8F9FC',
    grayBlue100: '#EAECF5',
    grayBlue200: '#D5D9EB',
    grayBlue300: '#B3B8DB',
    grayBlue400: '#717BBC',
    grayBlue500: '#4E5BA6',
    grayBlue600: '#3E4784',
    grayBlue700: '#363F72',
    grayBlue800: '#293056',
    grayBlue900: '#101323',
    grayCool25: '#FCFCFD',
    grayCool50: '#F9F9FB',
    grayCool100: '#EFF1F5',
    grayCool200: '#DCDFEA',
    grayCool300: '#B9C0D4',
    grayCool400: '#7D89B0',
    grayCool500: '#5D6B98',
    grayCool600: '#4A5578',
    grayCool700: '#404968',
    grayCool800: '#30374F',
    grayCool900: '#111322',
    grayModern25: '#FCFCFD',
    grayModern50: '#F8FAFC',
    grayModern100: '#EEF2F6',
    grayModern200: '#E3E8EF',
    grayModern300: '#CDD5DF',
    grayModern400: '#9AA4B2',
    grayModern500: '#697586',
    grayModern600: '#4B5565',
    grayModern700: '#364152',
    grayModern800: '#202939',
    grayModern900: '#121926',
    grayNeutral25: '#FCFCFD',
    grayNeutral50: '#F9FAFB',
    grayNeutral100: '#F3F4F6',
    grayNeutral200: '#E5E7EB',
    grayNeutral300: '#D2D6DB',
    grayNeutral400: '#9DA4AE',
    grayNeutral500: '#6C737F',
    grayNeutral600: '#4D5761',
    grayNeutral700: '#384250',
    grayNeutral800: '#1F2A37',
    grayNeutral900: '#111927',
    grayIron25: '#FCFCFC',
    grayIron50: '#FAFAFA',
    grayIron100: '#F4F4F5',
    grayIron200: '#E4E4E7',
    grayIron300: '#D1D1D6',
    grayIron400: '#A0A0AB',
    grayIron500: '#70707B',
    grayIron600: '#51525C',
    grayIron700: '#3F3F46',
    grayIron800: '#26272B',
    grayIron900: '#18181B',
    grayTrue25: '#FCFCFC',
    grayTrue50: '#FAFAFA',
    grayTrue100: '#F5F5F5',
    grayTrue200: '#E5E5E5',
    grayTrue300: '#D6D6D6',
    grayTrue400: '#A3A3A3',
    grayTrue500: '#737373',
    grayTrue600: '#525252',
    grayTrue700: '#424242',
    grayTrue800: '#292929',
    grayTrue900: '#141414',
    grayWarm25: '#FDFDFC',
    grayWarm50: '#FAFAF9',
    grayWarm100: '#F5F5F4',
    grayWarm200: '#E7E5E4',
    grayWarm300: '#D7D3D0',
    grayWarm400: '#A9A29D',
    grayWarm500: '#79716B',
    grayWarm600: '#57534E',
    grayWarm700: '#44403C',
    grayWarm800: '#292524',
    grayWarm900: '#1C1917',
    moss25: '#FAFDF7',
    moss50: '#F5FBEE',
    moss100: '#E6F4D7',
    moss200: '#CEEAB0',
    moss300: '#ACDC79',
    moss400: '#86CB3C',
    moss500: '#669F2A',
    moss600: '#4F7A21',
    moss700: '#3F621A',
    moss800: '#335015',
    moss900: '#2B4212',
    greenLight25: '#FAFEF5',
    greenLight50: '#F3FEE7',
    greenLight100: '#E3FBCC',
    greenLight200: '#D0F8AB',
    greenLight300: '#A6EF67',
    greenLight400: '#85E13A',
    greenLight500: '#66C61C',
    greenLight600: '#4CA30D',
    greenLight700: '#3B7C0F',
    greenLight800: '#326212',
    greenLight900: '#2B5314',
    green25: '#F6FEF9',
    green50: '#EDFCF2',
    green100: '#D3F8DF',
    green200: '#AAF0C4',
    green300: '#73E2A3',
    green400: '#3CCB7F',
    green500: '#16B364',
    green600: '#099250',
    green700: '#087443',
    green800: '#095C37',
    green900: '#084C2E',
    teal25: '#F6FEFC',
    teal50: '#F0FDF9',
    teal100: '#CCFBEF',
    teal200: '#99F6E0',
    teal300: '#5FE9D0',
    teal400: '#2ED3B7',
    teal500: '#15B79E',
    teal600: '#0E9384',
    teal700: '#107569',
    teal800: '#125D56',
    teal900: '#134E48',
    cyan25: '#F5FEFF',
    cyan50: '#ECFDFF',
    cyan100: '#CFF9FE',
    cyan200: '#A5F0FC',
    cyan300: '#67E3F9',
    cyan400: '#22CCEE',
    cyan500: '#06AED4',
    cyan600: '#088AB2',
    cyan700: '#0E7090',
    cyan800: '#155B75',
    cyan900: '#164C63',
    blueLight25: '#F5FBFF',
    blueLight50: '#F0F9FF',
    blueLight100: '#E0F2FE',
    blueLight200: '#B9E6FE',
    blueLight300: '#7CD4FD',
    blueLight400: '#36BFFA',
    blueLight500: '#0BA5EC',
    blueLight600: '#0086C9',
    blueLight700: '#026AA2',
    blueLight800: '#065986',
    blueLight900: '#0B4A6F',
    blue25: '#F5FAFF',
    blue50: '#EFF8FF',
    blue100: '#D1E9FF',
    blue200: '#B2DDFF',
    blue300: '#84CAFF',
    blue400: '#53B1FD',
    blue500: '#2E90FA',
    blue600: '#1570EF',
    blue700: '#175CD3',
    blue800: '#1849A9',
    blue900: '#194185',
    blueDark25: '#F5F8FF',
    blueDark50: '#EFF4FF',
    blueDark100: '#D1E0FF',
    blueDark200: '#B2CCFF',
    blueDark300: '#84ADFF',
    blueDark400: '#528BFF',
    blueDark500: '#2970FF',
    blueDark600: '#155EEF',
    blueDark700: '#004EEB',
    blueDark800: '#0040C1',
    blueDark900: '#00359E',
    indigo25: '#F5F8FF',
    indigo50: '#EEF4FF',
    indigo100: '#E0EAFF',
    indigo200: '#C7D7FE',
    indigo300: '#A4BCFD',
    indigo400: '#8098F9',
    indigo500: '#6172F3',
    indigo600: '#444CE7',
    indigo700: '#3538CD',
    indigo800: '#2D31A6',
    indigo900: '#2D3282',
    violet25: '#FBFAFF',
    violet50: '#F5F3FF',
    violet100: '#ECE9FE',
    violet200: '#DDD6FE',
    violet300: '#C3B5FD',
    violet400: '#A48AFB',
    violet500: '#875BF7',
    violet600: '#7839EE',
    violet700: '#6927DA',
    violet800: '#5720B7',
    violet900: '#491C96',
    purple25: '#FAFAFF',
    purple50: '#F4F3FF',
    purple100: '#EBE9FE',
    purple200: '#D9D6FE',
    purple300: '#BDB4FE',
    purple400: '#9B8AFB',
    purple500: '#7A5AF8',
    purple600: '#6938EF',
    purple700: '#5925DC',
    purple800: '#4A1FB8',
    purple900: '#3E1C96',
    fuchsia25: '#FEFAFF',
    fuchsia50: '#FDF4FF',
    fuchsia100: '#FBE8FF',
    fuchsia200: '#F6D0FE',
    fuchsia300: '#EEAAFD',
    fuchsia400: '#E478FA',
    fuchsia500: '#D444F1',
    fuchsia600: '#BA24D5',
    fuchsia700: '#9F1AB1',
    fuchsia800: '#821890',
    fuchsia900: '#6F1877',
    pink25: '#FEF6FB',
    pink50: '#FDF2FA',
    pink100: '#FCE7F6',
    pink200: '#FCCEEE',
    pink300: '#FAA7E0',
    pink400: '#F670C7',
    pink500: '#EE46BC',
    pink600: '#DD2590',
    pink700: '#C11574',
    pink800: '#9E165F',
    pink900: '#851651',
    rose25: '#FFF5F6',
    rose50: '#FFF1F3',
    rose100: '#FFE4E8',
    rose200: '#FECDD6',
    rose300: '#FEA3B4',
    rose400: '#FD6F8E',
    rose500: '#F63D68',
    rose600: '#E31B54',
    rose700: '#C01048',
    rose800: '#A11043',
    rose900: '#89123E',
    orangeDark25: '#FFF9F5',
    orangeDark50: '#FFF4ED',
    orangeDark100: '#FFE6D5',
    orangeDark200: '#FFD6AE',
    orangeDark300: '#FF9C66',
    orangeDark400: '#FF692E',
    orangeDark500: '#FF4405',
    orangeDark600: '#E62E05',
    orangeDark700: '#BC1B06',
    orangeDark800: '#97180C',
    orangeDark900: '#771A0D',
    orange25: '#FEFAF5',
    orange50: '#FEF6EE',
    orange100: '#FDEAD7',
    orange200: '#F9DBAF',
    orange300: '#F7B27A',
    orange400: '#F38744',
    orange500: '#EF6820',
    orange600: '#E04F16',
    orange700: '#B93815',
    orange800: '#932F19',
    orange900: '#772917',
    yellow25: '#FEFDF0',
    yellow50: '#FEFBE8',
    yellow100: '#FEF7C3',
    yellow200: '#FEEE95',
    yellow300: '#FDE272',
    yellow400: '#FAC515',
    yellow500: '#EAAA08',
    yellow600: '#CA8504',
    yellow700: '#A15C07',
    yellow800: '#854A0E',
    yellow900: '#713B12'
};
export const defaultGradients = {
    gradientNeutral600_500_90deg: 'linear-gradient(90deg, $neutral600 0%, $neutral500 100%)',
    gradientNeutral700_600_45deg: 'linear-gradient(45deg, $neutral700 0%, $neutral600 100%)',
    gradientNeutral800_600_45deg: 'linear-gradient(45deg, $neutral800 0%, $neutral600 100%)',
    gradientNeutral800_600_90deg: 'linear-gradient(90deg, $neutral800 0%, $neutral600 100%)',
    gradientNeutral800_700_26_5deg: 'linear-gradient(26.5deg, $neutral800 0%, $neutral700 100%)',
    gradientNeutral900_600_45deg: 'linear-gradient(45deg, $neutral900 0%, $neutral600 100%)',
    gradientPrimary600_500_90deg: 'linear-gradient(90deg,$primary600 0%, $primary500 100%)',
    gradientPrimary700_600_45deg: 'linear-gradient(45deg, $primary700 0%, $primary600 100%)',
    gradientPrimary800_600_45deg: 'linear-gradient(45deg, $primary800 0%, $primary600 100%)',
    gradientPrimary800_600_90deg: 'linear-gradient(90deg, $primary800 0%, $primary600 100%)',
    gradientPrimary800_700_26_5deg: 'linear-gradient(26.5deg, $primary800 0%, $primary700 100%)',
    gradientPrimary900_600_45deg: 'linear-gradient(45deg, $primary900 0%, $primary600 100%)'
};
export const defaultColors = {
    ...defaultSemanticColors,
    ...defaultMiscColors,
    buttonNeutralBg: '$surface',
    buttonNeutralBorder: '$neutral300',
    buttonNeutralText: '$text',
    buttonNeutralBgHover: '$neutral50',
    buttonNeutralBorderHover: '$neutral300',
    buttonNeutralTextHover: '$text',
    buttonNeutralBgActive: '$surface',
    buttonNeutralBorderActive: '$neutral300',
    buttonNeutralTextActive: '$text',
    buttonNeutralBgFocus: '$surface',
    buttonNeutralBorderFocus: '$neutral300',
    buttonNeutralTextFocus: '$text',
    buttonNeutralBgDisabled: '$buttonNeutralBg',
    buttonNeutralBorderDisabled: '$buttonNeutralBorder',
    buttonNeutralTextDisabled: '$buttonNeutralText',
    buttonNeutralFadedBg: 'transparent',
    buttonNeutralFadedBorder: 'transparent',
    buttonNeutralFadedText: '$textMuted',
    buttonNeutralFadedBgHover: 'transparent',
    buttonNeutralFadedBorderHover: 'transparent',
    buttonNeutralFadedTextHover: '$neutral900',
    buttonNeutralFadedBgActive: 'transparent',
    buttonNeutralFadedBorderActive: 'transparent',
    buttonNeutralFadedTextActive: '$text',
    buttonNeutralFadedBgFocus: 'transparent',
    buttonNeutralFadedBorderFocus: 'transparent',
    buttonNeutralFadedTextFocus: '$text',
    buttonNeutralFadedBgDisabled: '$buttonNeutralFadedBg',
    buttonNeutralFadedBorderDisabled: '$buttonNeutralFadedBorder',
    buttonNeutralFadedTextDisabled: '$buttonNeutralFadedText',
    buttonNeutralGhostBg: 'transparent',
    buttonNeutralGhostBorder: 'transparent',
    buttonNeutralGhostText: '$textMuted',
    buttonNeutralGhostBgHover: '$neutral50',
    buttonNeutralGhostBorderHover: '$neutral50',
    buttonNeutralGhostTextHover: '$text',
    buttonNeutralGhostBgActive: 'transparent',
    buttonNeutralGhostBorderActive: 'transparent',
    buttonNeutralGhostTextActive: '$text',
    buttonNeutralGhostBgFocus: 'transparent',
    buttonNeutralGhostBorderFocus: 'transparent',
    buttonNeutralGhostTextFocus: '$text',
    buttonNeutralGhostBgDisabled: '$buttonNeutralFadedBg',
    buttonNeutralGhostBorderDisabled: '$buttonNeutralFadedBorder',
    buttonNeutralGhostTextDisabled: '$buttonNeutralFadedText',
    buttonNeutralLinkText: '$neutral500',
    buttonNeutralLinkTextHover: '$neutral600',
    buttonNeutralLinkTextActive: '$neutral600',
    buttonNeutralLinkTextFocus: '$neutral600',
    buttonNeutralLinkTextDisabled: '$buttonNeutralLinkText',
    buttonPrimaryBg: '$primary',
    buttonPrimaryBorder: '$primary',
    buttonPrimaryText: '$white',
    buttonPrimaryBgHover: '$primary700',
    buttonPrimaryBorderHover: '$primary700',
    buttonPrimaryTextHover: '$white',
    buttonPrimaryBgActive: '$primary',
    buttonPrimaryBorderActive: '$primary',
    buttonPrimaryTextActive: '$white',
    buttonPrimaryBgFocus: '$primary',
    buttonPrimaryBorderFocus: '$primary',
    buttonPrimaryTextFocus: '$white',
    buttonPrimaryBgDisabled: '$buttonPrimaryBg',
    buttonPrimaryBorderDisabled: '$buttonPrimaryBorder',
    buttonPrimaryTextDisabled: '$buttonPrimaryText',
    buttonPrimaryFadedBg: '$primary50',
    buttonPrimaryFadedBorder: '$primary50',
    buttonPrimaryFadedText: '$primary700',
    buttonPrimaryFadedBgHover: '$primary100',
    buttonPrimaryFadedBorderHover: '$primary100',
    buttonPrimaryFadedTextHover: '$primary700',
    buttonPrimaryFadedBgActive: '$primary50',
    buttonPrimaryFadedBorderActive: '$primary50',
    buttonPrimaryFadedTextActive: '$primary700',
    buttonPrimaryFadedBgFocus: '$primary50',
    buttonPrimaryFadedBorderFocus: '$primary50',
    buttonPrimaryFadedTextFocus: '$primary700',
    buttonPrimaryFadedBgDisabled: '$buttonPrimaryFadedBg',
    buttonPrimaryFadedBorderDisabled: '$buttonPrimaryFadedBorder',
    buttonPrimaryFadedTextDisabled: '$buttonPrimaryFadedText',
    buttonPrimaryGhostBg: 'transparent',
    buttonPrimaryGhostBorder: 'transparent',
    buttonPrimaryGhostText: '$primary700',
    buttonPrimaryGhostBgHover: '$primary50',
    buttonPrimaryGhostBorderHover: '$primary50',
    buttonPrimaryGhostTextHover: '$primary700',
    buttonPrimaryGhostBgActive: 'transparent',
    buttonPrimaryGhostBorderActive: 'transparent',
    buttonPrimaryGhostTextActive: '$primary700',
    buttonPrimaryGhostBgFocus: 'transparent',
    buttonPrimaryGhostBorderFocus: 'transparent',
    buttonPrimaryGhostTextFocus: '$primary700',
    buttonPrimaryGhostBgDisabled: '$buttonPrimaryGhostBg',
    buttonPrimaryGhostBorderDisabled: '$buttonPrimaryGhostBorder',
    buttonPrimaryGhostTextDisabled: '$buttonPrimaryGhostText',
    buttonPrimaryLinkText: '$primary700',
    buttonPrimaryLinkTextHover: '$primary800',
    buttonPrimaryLinkTextActive: '$primary800',
    buttonPrimaryLinkTextFocus: '$primary800',
    buttonPrimaryLinkTextDisabled: '$buttonPrimaryLinkText',
    buttonSecondaryBg: '$secondary',
    buttonSecondaryBorder: '$secondary',
    buttonSecondaryText: '$white',
    buttonSecondaryBgHover: '$secondary700',
    buttonSecondaryBorderHover: '$secondary700',
    buttonSecondaryTextHover: '$white',
    buttonSecondaryBgActive: '$secondary',
    buttonSecondaryBorderActive: '$secondary',
    buttonSecondaryTextActive: '$white',
    buttonSecondaryBgFocus: '$secondary',
    buttonSecondaryBorderFocus: '$secondary',
    buttonSecondaryTextFocus: '$white',
    buttonSecondaryBgDisabled: '$buttonSecondaryBg',
    buttonSecondaryBorderDisabled: '$buttonSecondaryBorder',
    buttonSecondaryTextDisabled: '$buttonSecondaryText',
    buttonDangerBg: '$danger',
    buttonDangerBorder: '$danger',
    buttonDangerText: '$white',
    buttonDangerBgHover: '$danger700',
    buttonDangerBorderHover: '$danger700',
    buttonDangerTextHover: '$white',
    buttonDangerBgActive: '$danger',
    buttonDangerBorderActive: '$danger',
    buttonDangerTextActive: '$white',
    buttonDangerBgFocus: '$danger',
    buttonDangerBorderFocus: '$danger',
    buttonDangerTextFocus: '$white',
    buttonDangerBgDisabled: '$buttonDangerBg',
    buttonDangerBorderDisabled: '$buttonDangerBorder',
    buttonDangerTextDisabled: '$buttonDangerText',
    buttonDangerNeutralBg: '$surface',
    buttonDangerNeutralBorder: '$danger300',
    buttonDangerNeutralText: '$danger700',
    buttonDangerNeutralBgHover: '$danger50',
    buttonDangerNeutralBorderHover: '$danger300',
    buttonDangerNeutralTextHover: '$danger700',
    buttonDangerNeutralBgActive: '$surface',
    buttonDangerNeutralBorderActive: '$danger300',
    buttonDangerNeutralTextActive: '$danger700',
    buttonDangerNeutralBgFocus: '$surface',
    buttonDangerNeutralBorderFocus: '$danger300',
    buttonDangerNeutralTextFocus: '$danger700',
    buttonDangerNeutralBgDisabled: '$buttonDangerNeutralBg',
    buttonDangerNeutralBorderDisabled: '$buttonDangerNeutralBorder',
    buttonDangerNeutralTextDisabled: '$buttonDangerNeutralText',
    buttonDangerFadedBg: '$danger50',
    buttonDangerFadedBorder: '$danger50',
    buttonDangerFadedText: '$danger700',
    buttonDangerFadedBgHover: '$danger100',
    buttonDangerFadedBorderHover: '$danger100',
    buttonDangerFadedTextHover: '$danger700',
    buttonDangerFadedBgActive: '$danger50',
    buttonDangerFadedBorderActive: '$danger50',
    buttonDangerFadedTextActive: '$danger700',
    buttonDangerFadedBgFocus: '$danger50',
    buttonDangerFadedBorderFocus: '$danger50',
    buttonDangerFadedTextFocus: '$danger700',
    buttonDangerFadedBgDisabled: '$buttonDangerFadedBg',
    buttonDangerFadedBorderDisabled: '$buttonDangerFadedBorder',
    buttonDangerFadedTextDisabled: '$buttonDangerFadedText',
    buttonDangerGhostBg: 'transparent',
    buttonDangerGhostBorder: 'transparent',
    buttonDangerGhostText: '$danger700',
    buttonDangerGhostBgHover: '$danger50',
    buttonDangerGhostBorderHover: '$danger50',
    buttonDangerGhostTextHover: '$danger700',
    buttonDangerGhostBgActive: 'transparent',
    buttonDangerGhostBorderActive: 'transparent',
    buttonDangerGhostTextActive: '$danger700',
    buttonDangerGhostBgFocus: 'transparent',
    buttonDangerGhostBorderFocus: 'transparent',
    buttonDangerGhostTextFocus: '$danger700',
    buttonDangerGhostBgDisabled: '$buttonNeutralFadedBg',
    buttonDangerGhostBorderDisabled: '$buttonNeutralFadedBorder',
    buttonDangerGhostTextDisabled: '$buttonNeutralFadedText',
    buttonDangerLinkText: '$danger700',
    buttonDangerLinkTextHover: '$danger800',
    buttonDangerLinkTextActive: '$danger800',
    buttonDangerLinkTextFocus: '$danger800',
    buttonDangerLinkTextDisabled: '$danger700',
    inputPlaceholder: '$textMuted',
    inputBg: '$surface',
    inputBorder: '$borderColor',
    inputText: '$neutral900',
    // inputBgHover: '$surface',
    // inputBorderHover: '$borderColor',
    // inputTextHover: '$neutral900',
    inputBgActive: '$surface',
    inputBorderActive: '$borderColor',
    inputTextActive: '$neutral900',
    inputBgFocus: '$surface',
    inputBorderFocus: '$primary300',
    inputTextFocus: '$neutral900',
    inputBgDisabled: '$surface',
    inputBorderDisabled: '$borderColor',
    inputTextDisabled: '$neutral900',
    inputAddonBg: '$neutral50',
    checkboxBg: 'transparent',
    checkboxBorder: '$borderColor',
    checkboxIndicator: '$primary',
    checkboxBgHover: '$primary100',
    checkboxBorderHover: '$primary',
    checkboxIndicatorHover: '$primary',
    checkboxBgActive: '$primary100',
    checkboxBorderActive: '$primary',
    checkboxIndicatorActive: '$primary',
    checkboxBgFocus: '$primary100',
    checkboxBorderFocus: '$primary',
    checkboxIndicatorFocus: '$primary',
    checkboxBgDisabled: '$checkboxBg',
    checkboxBorderDisabled: '$checkboxBorder',
    checkboxIndicatorDisabled: '$checkboxIndicator',
    checkboxBgChecked: '$primary100',
    checkboxBorderChecked: '$primary',
    checkboxIndicatorChecked: '$primary',
    checkboxCircleBgChecked: '$checkboxIndicator',
    checkboxCircleBorderChecked: '$checkboxIndicator',
    checkboxCircleIndicatorChecked: '$hiContrast',
    radioBg: 'transparent',
    radioBorder: '$borderColor',
    radioIndicator: '$primary',
    radioBgHover: '$primary100',
    radioBorderHover: '$primary',
    radioIndicatorHover: '$primary',
    radioBgActive: '$primary100',
    radioBorderActive: '$primary',
    radioIndicatorActive: '$primary',
    radioBgFocus: '$primary100',
    radioBorderFocus: '$primary',
    radioIndicatorFocus: '$primary',
    radioBgDisabled: '$radioBg',
    radioBorderDisabled: '$radioBorder',
    radioIndicatorDisabled: '$radioIndicator',
    radioBgChecked: '$primary100',
    radioBorderChecked: '$primary',
    radioIndicatorChecked: '$primary',
    toggleBg: '$neutral100',
    toggleBorder: '$neutral100',
    toggleIndicator: '$surface',
    toggleBgHover: '$neutral200',
    toggleBorderHover: '$neutral200',
    toggleIndicatorHover: '$surface',
    toggleBgActive: '$neutral200',
    toggleBorderActive: '$neutral200',
    toggleIndicatorActive: '$surface',
    toggleBgFocus: '$neutral200',
    toggleBorderFocus: '$neutral200',
    toggleIndicatorFocus: '$surface',
    toggleBgDisabled: '$toggleBg',
    toggleBorderDisabled: '$toggleBgBorder',
    toggleIndicatorDisabled: '$toggleBgIndicator',
    toggleBgChecked: '$primary',
    toggleBorderChecked: '$primary',
    toggleIndicatorChecked: '$surface',
    avatarPlaceholderBg: '$neutral50',
    avatarPlaceholderText: '$neutral600',
    progressBarBg: '$neutral200',
    progressBarIndicator: 'currentColor',
    sliderTrackBg: '$neutral200',
    sliderRangeBg: '$primary',
    sliderThumbBg: '$surface',
    sliderThumbBorder: '$primary',
    tabsDefaultActiveTriggerText: '$text',
    tabsDefaultActiveTriggerBg: '$neutral50',
    tabsPrimaryActiveTriggerText: '$primary700',
    tabsPrimaryActiveTriggerBg: '$primary50',
    tabsElevatedBg: '$neutral50',
    tabsElevatedBorder: '$neutral100',
    tabsElevatedActiveTriggerText: '$text',
    tabsElevatedActiveTriggerBg: '$surface',
    featuredIconNeutralBg: '$neutral100',
    featuredIconNeutralDarkBg: '$neutral500',
    featuredIconNeutralBorder: '$neutral50',
    featuredIconNeutralDarkBorder: '$neutral600',
    featuredIconNeutralText: '$neutral600',
    featuredIconPrimaryBg: '$primary100',
    featuredIconPrimaryDarkBg: '$primary500',
    featuredIconPrimaryBorder: '$primary50',
    featuredIconPrimaryDarkBorder: '$primary',
    featuredIconPrimaryText: '$primary',
    featuredIconPrimaryMidBg: '$primary500',
    featuredIconPrimaryMidText: '$hiContrast',
    featuredIconPrimaryDarkerBg: '$primary800',
    featuredIconPrimaryDarkerText: '$hiContrast',
    featuredIconDangerBg: '$danger100',
    featuredIconDangerDarkBg: '$danger500',
    featuredIconDangerBorder: '$danger50',
    featuredIconDangerDarkBorder: '$danger',
    featuredIconDangerText: '$danger',
    featuredIconWarningBg: '$warning100',
    featuredIconWarningDarkBg: '$warning500',
    featuredIconWarningBorder: '$warning50',
    featuredIconWarningDarkBorder: '$warning',
    featuredIconWarningText: '$warning',
    featuredIconSuccessBg: '$success100',
    featuredIconSuccessDarkBg: '$success500',
    featuredIconSuccessBorder: '$success50',
    featuredIconSuccessDarkBorder: '$success',
    featuredIconSuccessText: '$success',
    badgeNeutralBg: '$neutral100',
    badgeNeutralText: '$neutral700',
    badgePrimaryBg: '$primary100',
    badgePrimaryText: '$primary700',
    badgeDangerBg: '$danger100',
    badgeDangerText: '$danger700',
    badgeWarningBg: '$warning100',
    badgeWarningText: '$warning700',
    badgeSuccessBg: '$success100',
    badgeSuccessText: '$success700',
    badgeGroupNeutralLightBg: '$neutral50',
    badgeGroupNeutralLightText: '$neutral700',
    badgeGroupNeutralLightBadgeBg: '$hiContrast',
    badgeGroupNeutralLightBadgeText: '$neutral700',
    badgeGroupNeutralMidBg: '$neutral100',
    badgeGroupNeutralMidText: '$neutral700',
    badgeGroupNeutralMidBadgeBg: '$neutral200',
    badgeGroupNeutralMidBadgeText: '$neutral700',
    badgeGroupNeutralDarkBg: '$neutral50',
    badgeGroupNeutralDarkText: '$neutral700',
    badgeGroupNeutralDarkBadgeBg: '$neutral700',
    badgeGroupNeutralDarkBadgeText: '$hiContrast',
    badgeGroupPrimaryLightBg: '$primary50',
    badgeGroupPrimaryLightText: '$primary700',
    badgeGroupPrimaryLightBadgeBg: '$hiContrast',
    badgeGroupPrimaryLightBadgeText: '$primary700',
    badgeGroupPrimaryMidBg: '$primary100',
    badgeGroupPrimaryMidText: '$primary700',
    badgeGroupPrimaryMidBadgeBg: '$primary50',
    badgeGroupPrimaryMidBadgeText: '$primary700',
    badgeGroupPrimaryDarkBg: '$primary50',
    badgeGroupPrimaryDarkText: '$primary700',
    badgeGroupPrimaryDarkBadgeBg: '$primary',
    badgeGroupPrimaryDarkBadgeText: '$hiContrast',
    badgeGroupDangerLightBg: '$danger50',
    badgeGroupDangerLightText: '$danger700',
    badgeGroupDangerLightBadgeBg: '$hiContrast',
    badgeGroupDangerLightBadgeText: '$danger700',
    badgeGroupDangerMidBg: '$danger100',
    badgeGroupDangerMidText: '$danger700',
    badgeGroupDangerMidBadgeBg: '$danger50',
    badgeGroupDangerMidBadgeText: '$danger700',
    badgeGroupDangerDarkBg: '$danger50',
    badgeGroupDangerDarkText: '$danger700',
    badgeGroupDangerDarkBadgeBg: '$danger',
    badgeGroupDangerDarkBadgeText: '$hiContrast',
    badgeGroupWarningLightBg: '$warning50',
    badgeGroupWarningLightText: '$warning700',
    badgeGroupWarningLightBadgeBg: '$hiContrast',
    badgeGroupWarningLightBadgeText: '$warning700',
    badgeGroupWarningMidBg: '$warning100',
    badgeGroupWarningMidText: '$warning700',
    badgeGroupWarningMidBadgeBg: '$warning50',
    badgeGroupWarningMidBadgeText: '$warning700',
    badgeGroupWarningDarkBg: '$warning50',
    badgeGroupWarningDarkText: '$warning700',
    badgeGroupWarningDarkBadgeBg: '$warning',
    badgeGroupWarningDarkBadgeText: '$hiContrast',
    badgeGroupSuccessLightBg: '$success50',
    badgeGroupSuccessLightText: '$success700',
    badgeGroupSuccessLightBadgeBg: '$hiContrast',
    badgeGroupSuccessLightBadgeText: '$success700',
    badgeGroupSuccessMidBg: '$success100',
    badgeGroupSuccessMidText: '$success700',
    badgeGroupSuccessMidBadgeBg: '$success50',
    badgeGroupSuccessMidBadgeText: '$success700',
    badgeGroupSuccessDarkBg: '$success50',
    badgeGroupSuccessDarkText: '$success700',
    badgeGroupSuccessDarkBadgeBg: '$success',
    badgeGroupSuccessDarkBadgeText: '$hiContrast',
    tooltipLightBg: '$surface',
    tooltipLightText: '$text',
    tooltipDarkBg: '$neutral900',
    tooltipDarkText: '$hiContrast',
    popoverBg: '$surface',
    popoverBorder: '$neutral100',
    // ------------------------------------------------------------------------
    // ******* Gradients *******************************************************
    // ------------------------------------------------------------------------
    ...defaultGradients
};
export const systemColorVariants = [
    'primary',
    'neutral',
    'danger',
    'warning',
    'success'
].reduce((memo, prefix) => [
    ...memo,
    ...['', 'Faded', 'Ghost'].reduce((memo, prefix2) => [
        ...memo,
        `${prefix}${prefix2}Main`,
        `${prefix}${prefix2}Hover`,
        `${prefix}${prefix2}Focus`,
        `${prefix}${prefix2}Active`,
        `${prefix}${prefix2}BorderMain`,
        `${prefix}${prefix2}BorderHover`,
        `${prefix}${prefix2}BorderFocus`,
        `${prefix}${prefix2}BorderActive`,
        `${prefix}${prefix2}TextMain`,
        `${prefix}${prefix2}TextHover`,
        `${prefix}${prefix2}TextFocus`,
        `${prefix}${prefix2}TextActive`
    ], [])
], []);
export const systemColors = [
    'hiContrast',
    'loContrast',
    'text',
    'textContrast',
    'textMuted',
    'textMutedContrast',
    'borderColor',
    'separatorColor',
    'bodyBg',
    'surface',
    'link',
    'backdrop',
    ...systemColorVariants
];
export const defaultTokens = {
    space: defaultSpacing,
    breakpoints: defaultBreakpoints,
    colors: defaultColors,
    fontSizes: {
        htmlFontSize: '16px',
        xs: pxToRem(12),
        sm: pxToRem(14),
        md: pxToRem(16),
        lg: pxToRem(18),
        xl: pxToRem(20),
        '2xl': pxToRem(24),
        '3xl': pxToRem(30),
        '4xl': pxToRem(36),
        '5xl': pxToRem(48),
        '6xl': pxToRem(60),
        '7xl': pxToRem(72),
        buttonSmFontSize: '$sm',
        buttonMdFontSize: '$sm',
        buttonLgFontSize: '$md',
        buttonXlFontSize: '$md',
        button2XlFontSize: '$lg',
        inputSmFontSize: '$sm',
        inputMdFontSize: '$sm',
        inputLgFontSize: '$md',
        inputXlFontSize: '$lg',
        input2XlFontSize: '$lg'
    },
    fonts: {
        sans: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI','Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans','Helvetica Neue', sans-serif;",
        mono: "Menlo, Monaco, 'Lucida Console', 'Liberation Mono', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono','Courier New', monospace;",
        heading: '$fonts$sans'
    },
    fontWeights: {
        regular: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        buttonSmFontWeight: '$medium',
        buttonMdFontWeight: '$medium',
        buttonLgFontWeight: '$medium',
        buttonXlFontWeight: '$medium',
        button2XlFontWeight: '$medium',
        inputSmFontWeight: '$buttonSmFontWeight',
        inputMdFontWeight: '$buttonMdFontWeight',
        inputLgFontWeight: '$buttonLgFontWeight',
        inputXlFontWeight: '$buttonXlFontWeight',
        input2XlFontWeight: '$button2XlFontWeight'
    },
    lineHeights: {
        none: 1,
        xs: '18px',
        sm: '20px',
        md: '24px',
        lg: '28px',
        xl: '30px',
        '2xl': '32px',
        '3xl': '36px',
        '4xl': '38px',
        '5xl': '44px',
        '6xl': '60px',
        '7xl': '72px',
        '8xl': '90px'
    },
    letterSpacings: {
        tighter: '-0.02em',
        tight: '-0.015em',
        normal: '0em',
        wide: '0.025em',
        wider: '0.05em'
    },
    sizes: {
        ...defaultSpacing,
        '1of2': '50%',
        '1of3': '33.333333%',
        '2of3': '66.666667%',
        '1of4': '25%',
        '2of4': '50%',
        '3of4': '75%',
        '1of5': '20%',
        '2of5': '40%',
        '3of5': '60%',
        '4of5': '80%',
        '1of6': '16.666667%',
        '2of6': '33.333333%',
        '3of6': '50%',
        '4of6': '66.666667%',
        '5of6': '83.333333%',
        '1of12': '8.333333%',
        '2of12': '16.666667%',
        '3of12': '25%',
        '4of12': '33.333333%',
        '5of12': '41.666667%',
        '6of12': '50%',
        '7of12': '58.333333%',
        '8of12': '66.666667%',
        '9of12': '75%',
        '10of12': '83.333333%',
        '11of12': '91.666667%',
        full: '100%',
        screen: '100vw',
        screenH: 'calc(100vh - calc(100vh - 100%))',
        min: 'min-content',
        max: 'max-content',
        fit: 'fit-content',
        screenSm: defaultBreakpoints.sm,
        screenMd: defaultBreakpoints.md,
        screenLg: defaultBreakpoints.lg,
        screenXl: defaultBreakpoints.xl,
        screen2Xl: defaultBreakpoints['2xl'],
        containerSm: defaultBreakpoints.sm,
        containerMd: defaultBreakpoints.md,
        containerLg: defaultBreakpoints.lg,
        containerXl: defaultBreakpoints.xl,
        container2xl: defaultBreakpoints['2xl'],
        containerPadding: '1rem',
        buttonSmHeight: pxToRem(36),
        buttonMdHeight: pxToRem(40),
        buttonLgHeight: pxToRem(44),
        buttonXlHeight: pxToRem(48),
        button2XlHeight: pxToRem(60),
        inputSmHeight: '$buttonSmHeight',
        inputMdHeight: '$buttonMdHeight',
        inputLgHeight: '$buttonLgHeight',
        inputXlHeight: '$buttonXlHeight',
        input2XlHeight: '$button2XlHeight'
    },
    borderWidths: {
        '0': '0px',
        '1': '1px',
        '2': '2px',
        '4': '4px',
        '8': '8px'
    },
    radii: {
        none: '0px',
        sm: '0.125rem',
        base: '0.25rem',
        md: '0.375rem',
        lg: '0.5rem',
        xl: '0.625rem',
        '2xl': '0.75rem',
        '3xl': '0.875rem',
        '4xl': '1rem',
        '5xl': '1.5rem',
        squared: '33%',
        full: '9999px',
        buttonRadii: '$lg',
        inputRadii: '$lg'
    },
    shadows: {
        xs: '0px 1px 2px rgba(16, 24, 40, 0.05)',
        sm: '0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)',
        md: '0px 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)',
        lg: '0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)',
        xl: '0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)',
        '2xl': '0px 24px 48px -12px rgba(16, 24, 40, 0.18)',
        '3xl': '0px 32px 64px -12px rgba(16, 24, 40, 0.14)',
        focusRingPrimary: '0px 1px 2px rgb(127 86 217 / 30%), 0px 0px 0px 4px rgb(88 27 233 / 13%)',
        focusRingSecondary: '0px 1px 2px rgb(0 0 0 / 30%), 0px 0px 0px 4px rgb(0 0 0 / 13%)',
        focusRingNeutral: '0px 1px 2px rgb(0 0 0 / 8%), 0px 0px 0px 4px rgb(0 0 0 / 4%)',
        focusRingDanger: '0px 1px 2px rgb(233 27 27 / 10%), 0px 0px 0px 4px rgb(233 27 27 / 13%)',
        focusRingWarning: '0px 1px 2px rgb(247 144 9 / 10%), 0px 0px 0px 4px rgb(247 144 9 / 13%)',
        focusRingSuccess: '0px 1px 2px rgb(18 183 106 / 10%), 0px 0px 0px 4px rgb(18 183 106 / 13%)'
    },
    dropShadows: {},
    zIndices: {
        '0': '0',
        '10': '10',
        '20': '20',
        '30': '30',
        '40': '40',
        '50': '50'
    },
    transitions: {}
};
export const defaultThemeMap = {
    ...defaultStitchesThemeMap,
    borderWidth: 'borderWeights',
    top: 'sizes',
    right: 'sizes',
    bottom: 'sizes',
    left: 'sizes'
};
export const defaultMedia = {
    // ***************************************************************************
    // It doesn't make real media queries. It's just a hack to enable typesafe on @dark and @light.
    dark: '',
    light: '',
    // ***************************************************************************
    xs: `(max-width: ${Number(defaultTokens.breakpoints.sm.replace('px', '')) - 0.1}px)`,
    sm: `(min-width: ${defaultTokens.breakpoints.sm})`,
    md: `(min-width: ${defaultTokens.breakpoints.md})`,
    lg: `(min-width: ${defaultTokens.breakpoints.lg})`,
    xl: `(min-width: ${defaultTokens.breakpoints.xl})`,
    '2xl': `(min-width: ${defaultTokens.breakpoints['2xl']})`,
    motionReduce: '(prefers-reduced-motion: reduce)',
    motionNoPreference: '(prefers-reduced-motion: no-preference)',
    safari: 'not all and (min-resolution:.001dpcm)',
    hover: '(any-hover: hover)',
    '2x': '(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)'
};
export const defaultUtilities = {
    p: (value) => ({
        padding: value
    }),
    pt: (value) => ({
        paddingTop: value
    }),
    pr: (value) => ({
        paddingRight: value
    }),
    pb: (value) => ({
        paddingBottom: value
    }),
    pl: (value) => ({
        paddingLeft: value
    }),
    px: (value) => ({
        pl: value,
        pr: value
    }),
    py: (value) => ({
        pt: value,
        pb: value
    }),
    m: (value) => ({
        margin: value
    }),
    mt: (value) => ({
        marginTop: value
    }),
    mr: (value) => ({
        marginRight: value
    }),
    mb: (value) => ({
        marginBottom: value
    }),
    ml: (value) => ({
        marginLeft: value
    }),
    mx: (value) => ({
        ml: value,
        mr: value
    }),
    my: (value) => ({
        mt: value,
        mb: value
    }),
    d: (value) => ({ display: value }),
    flexCenter: (value) => value
        ? {
            d: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
        : {},
    flexRow: (value) => value
        ? {
            d: 'flex',
            flexDirection: 'row'
        }
        : {},
    flexRowCenter: (value) => value
        ? {
            flexRow: true,
            alignItems: 'center'
        }
        : {},
    flexCol: (value) => value
        ? {
            d: 'flex',
            flexDirection: 'column'
        }
        : {},
    flexColCenter: (value) => value
        ? {
            flexCol: true,
            alignItems: 'center'
        }
        : {},
    flexDir: (value) => ({
        flexDirection: value
    }),
    bgColor: (value) => ({
        backgroundColor: value
    }),
    bgFilter: (value) => ({
        backdropFilter: value
    }),
    bg: (value) => ({
        background: value
    }),
    bgBlur: (value) => ({
        bf: 'saturate(180%) blur(10px)',
        bg: value
    }),
    bgClip: (value) => ({
        WebkitBackgroundClip: value,
        backgroundClip: value
    }),
    bt: (value) => ({
        borderTop: value
    }),
    br: (value) => ({
        borderRight: value
    }),
    bb: (value) => ({
        borderBottom: value
    }),
    bl: (value) => ({
        borderLeft: value
    }),
    bx: (value) => ({
        bl: value,
        br: value
    }),
    by: (value) => ({
        bt: value,
        bb: value
    }),
    rounded: (value) => ({
        borderRadius: value
    }),
    roundedT: (value) => ({
        borderTopLeftRadius: value,
        borderTopRightRadius: value
    }),
    roundedR: (value) => ({
        borderTopRightRadius: value,
        borderBottomRightRadius: value
    }),
    roundedB: (value) => ({
        borderBottomLeftRadius: value,
        borderBottomRightRadius: value
    }),
    roundedL: (value) => ({
        borderTopLeftRadius: value,
        borderBottomLeftRadius: value
    }),
    roundedTR: (value) => ({
        borderTopRightRadius: value
    }),
    roundedBR: (value) => ({
        borderBottomRightRadius: value
    }),
    roundedBL: (value) => ({
        borderBottomLeftRadius: value
    }),
    roundedTL: (value) => ({
        borderTopLeftRadius: value
    }),
    shadow: (value) => ({
        boxShadow: value
    }),
    dropShadow: (value) => ({
        filter: `$dropShadows${value}`
    }),
    userSelect: (value) => ({
        WebkitUserSelect: value,
        userSelect: value
    }),
    w: (value) => ({ width: value }),
    h: (value) => ({ height: value }),
    minW: (value) => ({
        minWidth: value
    }),
    minH: (value) => ({
        minHeight: value
    }),
    maxW: (value) => ({
        maxWidth: value
    }),
    maxH: (value) => ({
        maxHeight: value
    }),
    minMaxW: (value) => ({
        width: value,
        minWidth: value,
        maxWidth: value
    }),
    minMaxH: (value) => ({
        height: value,
        minHeight: value,
        maxHeight: value
    }),
    size: (value) => ({
        width: value,
        height: value
    }),
    minSize: (value) => ({
        minWidth: value,
        minHeight: value
    }),
    maxSize: (value) => ({
        maxWidth: value,
        maxHeight: value
    }),
    minMaxSize: (value) => ({
        minWidth: value,
        minHeight: value,
        maxWidth: value,
        maxHeight: value,
        width: value,
        height: value
    }),
    appearance: (value) => ({
        WebkitAppearance: value,
        appearance: value
    }),
    scale: (value) => ({
        transform: `scale(${value})`
    }),
    linearGradient: (value) => ({
        backgroundImage: `linear-gradient(${value})`
    }),
    truncate: (value) => ({
        maxWidth: value,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }),
    noWrap: (value) => value
        ? {
            whiteSpace: 'nowrap'
        }
        : {},
    textGradient: (value) => ({
        backgroundImage: `linear-gradient(${value})`,
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        '&::selection': {
            WebkitTextFillColor: '$colors$text'
        }
    }),
    textXs: (value) => value
        ? { fontSize: '$xs', lineHeight: '$xs', letterSpacing: '$normal' }
        : {},
    textSm: (value) => value
        ? { fontSize: '$sm', lineHeight: '$sm', letterSpacing: '$normal' }
        : {},
    textMd: (value) => value
        ? { fontSize: '$md', lineHeight: '$md', letterSpacing: '$normal' }
        : {},
    textLg: (value) => value
        ? { fontSize: '$lg', lineHeight: '$lg', letterSpacing: '$normal' }
        : {},
    textXl: (value) => value
        ? { fontSize: '$xl', lineHeight: '$xl', letterSpacing: '$normal' }
        : {},
    textDisplayXs: (value) => value
        ? {
            fontFamily: '$heading',
            fontSize: '$2xl',
            lineHeight: '$2xl',
            letterSpacing: '$normal'
        }
        : {},
    textDisplaySm: (value) => value
        ? {
            fontFamily: '$heading',
            fontSize: '$3xl',
            lineHeight: '$4xl',
            letterSpacing: '$normal'
        }
        : {},
    textDisplayMd: (value) => value
        ? {
            fontFamily: '$heading',
            fontSize: '$4xl',
            lineHeight: '$5xl',
            letterSpacing: '$tighter'
        }
        : {},
    textDisplayLg: (value) => value
        ? {
            fontFamily: '$heading',
            fontSize: '$5xl',
            lineHeight: '$6xl',
            letterSpacing: '$tighter'
        }
        : {},
    textDisplayXl: (value) => value
        ? {
            fontFamily: '$heading',
            fontSize: '$6xl',
            lineHeight: '$7xl',
            letterSpacing: '$tighter'
        }
        : {},
    textDisplay2Xl: (value) => value
        ? {
            fontFamily: '$heading',
            fontSize: '$7xl',
            lineHeight: '$8xl',
            letterSpacing: '$tighter'
        }
        : {},
    grid: (value) => (value ? { d: 'grid' } : {}),
    gridCols: (value) => ({
        grid: true,
        gridTemplateColumns: value === 'none'
            ? 'none'
            : `repeat(${value.replace('$', '')}, minmax(0, 1fr))`
    }),
    gridRows: (value) => ({
        grid: true,
        gridTemplateRows: value === 'none'
            ? 'none'
            : `repeat(${value.replace('$', '')}, minmax(0, 1fr))`
    }),
    gridColSpan: (value) => ({
        gridColumn: value === '$full'
            ? 'grid-column: 1 / -1'
            : value.includes('$')
                ? `span ${value.replace('$', '')} / span ${value.replace('$', '')}`
                : value
    }),
    gridRowSpan: (value) => ({
        gridRow: value === '$full'
            ? 'grid-column: 1 / -1'
            : value.includes('$')
                ? `span ${value.replace('$', '')} / span ${value.replace('$', '')}`
                : value
    }),
    scrollX: (value) => ({
        overflowX: value,
        scrollBehavior: 'smooth',
        WebkitOverflowScrolling: 'touch'
    }),
    scrollY: (value) => ({
        overflowY: value,
        scrollBehavior: 'smooth',
        WebkitOverflowScrolling: 'touch'
    }),
    hideScrollbar: (value) => value
        ? {
            MsOverflowStyle: 'none' /* IE and Edge */,
            ScrollbarWidth: 'none' /* Firefox */,
            '&::-webkit-scrollbar': {
                display: 'none'
            }
        }
        : {},
    divideX: (value) => ({
        '& > * + *': {
            bl: value
        }
    }),
    divideY: (value) => ({
        '& > * + *': {
            bt: value
        }
    })
};
// *****************************************************************************
// Here we hack Stitches to make @dark and @light work.
defaultUtilities['@dark'] = (value) => ({
    '.dark &': value
});
defaultUtilities['@light'] = (value) => ({
    '.light &': value
});
// *****************************************************************************
